<template>
  <div class="common-empty-record">
    <img src="../assets/image/empty.png" alt="" />
    <p>{{ $t("noMore") }}</p>
  </div>
</template>

<script>
export default {
  name: "EmptyRecord",
  data() {
    return {};
  },
  props: {},
  methods: {},
};
</script>

<style scoped>
.common-empty-record {
  height: 300px;
  padding-top: 0px;
  background-color: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 200px;
    height: 200px;
  }
  p {
    color: black;
  }
}
</style>
